import { useEffect, useState } from 'react'
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { BreadcrumbLine } from '../../../../../../components/BreadcrumbLine/BreadcrumbLine';
import { ListMenuRoutes } from '../../../../../../components/ListMenu/ListMenuRoutes';
import { ModalConfirm } from '../../../../../../components/Modals/ModalConfirm';
import { isStatusSucess } from '../../../../../../helpers/helpers';
import { useForm } from '../../../../../../hooks/useForm';
import { useLang } from '../../../../../../language';
import { DatosGenerales } from './DatosGenerales/DatosGenerales';
import { Tarifas } from './Tarifas';
import { VerCalendario } from './VerCalendario';
import { ParametrosServices } from '../../../../../../services/parametros.service';
import { LoaderForm } from './LoaderForm';
import { AparatoServices } from './controllers/services/aparato.service';
import { AparatoAdapters } from './controllers/adapters/aparato.adapter';
import { Documentos } from './Documentos';

const Aparato = ({ pathName }: any) => {

  let params = useParams()

  const idaparato: string = String(params.id) || ''

  const nuevo = idaparato === 'nuevo'

  const Lang = useLang()

  const [formAparato, handleInputChangeAparato, handleFormChangeAparato, resetFormAparato] = useForm({
    ...AparatoAdapters.GET.receive.schema({})
  });

  const BreadcrumbLineItems = [
    {
      title: Lang('APARATOS'),
      link: '/alquiler-aparatos-admin/aparatos'
    },
    {
      title: `${nuevo ? Lang('APARATOS') : formAparato.producto}`,
      link: `/${idaparato}`
    }
  ]

  const [fetchAparatoGET, fetchAparatoGETData] = AparatoServices.GET()

  useEffect(() => {

    if (idaparato !== 'nuevo') {

      resetFormAparato()

      fetchAparatoGET({
        id: idaparato
      })

    }

  }, [idaparato]);

  useEffect(() => {

    if (isStatusSucess(fetchAparatoGETData.status)) {

      handleFormChangeAparato({
        ...fetchAparatoGETData.data
      })

    }
  }, [fetchAparatoGETData]);



  const listMenu: any = {
    datosGenerales: {
      title: Lang('DATOS_GENERALES'),
      link: 'datos-generales',
    },
    documentos: {
      title: Lang('DOCUMENTOS'),
      link: 'documentos',
    },
    tarifas: {
      title: Lang('TARIFAS'),
      link: 'tarifas',
    },
  }

  const listMenu2: any = {
    verCalendario: {
      title: Lang('VER_CALENDARIO'),
      link: 'ver-calendario',
    },
  }

  // const staticEstadosEventoServices: any = EstadosEventoServices.GET()

  const [showConfirm_CHANGE_ESTADO, setshowConfirm_CHANGE_ESTADO] = useState<any>({
    value: false,
    payload: {}
  })

  // const [fetchInscripcionPATCH, fetchInscripcionPATCHData] = InscripcionServices.PATCH_CHANGE_ESTADO(idevento)

  // useEffect(() => {

  //   if (isStatusSucess(fetchInscripcionPATCHData.status)) {

  //     setshowConfirm_CHANGE_ESTADO({
  //       value: false,
  //       payload: {}
  //     })
  //     fetchInscripcionGET()
  //   }

  // }, [fetchInscripcionPATCHData])

  // const handleChangeEstadoEvento = () => {

  //   fetchInscripcionPATCH({
  //     body: {
  //       estado: showConfirm_CHANGE_ESTADO.payload?.id
  //     }
  //   })
  // }

  // Parametros paises

  const [fetchParamsIdiomas, fetchParamsIdiomasData] = ParametrosServices.GET()

  useEffect(() => {

    fetchParamsIdiomas({
      params: {
        idiomas: true,
        filterfield: 'idiomas.codidioma',
        filtervalue: ['N'],
        filtertype: 'incluir',
      }
    })

  }, [])

  return (

    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-12">
          <div className='d-flex justify-content-between align-items-center mb-1 flex-wrap'>
            <BreadcrumbLine BreadcrumbLineItems={BreadcrumbLineItems} />
          </div>
        </div>

        {
          !nuevo && <div className="col-lg-3 mb-4">

            <ListMenuRoutes values={listMenu} />

            <div className="py-2"></div>

            <ListMenuRoutes values={listMenu2} />

          </div>
        }

        <div className="col-lg-9 animate__animated animate__fadeInUp">

          {
            fetchParamsIdiomasData.loading ?
              <div className="card p-3">
                <LoaderForm />
              </div>
              :
              <Routes>

                <Route
                  path='datos-generales'
                  element={
                    <DatosGenerales
                      idaparato={idaparato}
                      nuevo={nuevo}
                      formAparato={formAparato}
                      handleInputChangeAparato={handleInputChangeAparato}
                      fetchAparatoGETData={fetchAparatoGETData}
                      handleFormChangeAparato={handleFormChangeAparato}
                      fetchParamsIdiomasData={fetchParamsIdiomasData}
                    />
                  }
                />

                <Route
                  path='documentos'
                  element={
                    <Documentos
                      idaparato={idaparato}
                    />
                  }
                />

                <Route
                  path='tarifas'
                  element={
                    <Tarifas
                      idaparato={idaparato}
                      fetchAparatoGETData={fetchAparatoGETData}
                    />
                  }
                />

                <Route
                  path='ver-calendario'
                  element={
                    <VerCalendario 
                    idaparato={idaparato}

                    />
                  }
                />

                <Route
                  path="*"
                  element={<Navigate to='datos-generales' replace />}
                />
              </Routes>
          }

        </div>
      </div>

      <ModalConfirm
        handleClose={() => setshowConfirm_CHANGE_ESTADO({ value: false, payload: {} })}
        show={showConfirm_CHANGE_ESTADO.value}
        // onClickOK={handleChangeEstadoEvento}
        messageHTML={
          <h5 className='text-center fw-normal'>{Lang('PARRAFO_SEGURO_CAMBIAR_ESTADO_EVENTO_A')} {showConfirm_CHANGE_ESTADO.payload?.nombre}?</h5>
        }
        textOnClickOk={Lang('SI_CAMBIAR')}
      // fetchData={fetchInscripcionPATCHData}
      />

    </div>
  )
}

export default Aparato;